// Phase 25 iter-7 — password reset client.
//
//   POST /api/v1/auth/forgot-password  → 204 (always)
//   POST /api/v1/auth/reset-password   → TokenPair

import {
  API_VERSION_PREFIX,
  type ForgotPasswordRequest,
  type ResetPasswordRequest,
  type TokenPair,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function requestPasswordReset(input: ForgotPasswordRequest): Promise<void> {
  await apiClient.post(`${API_VERSION_PREFIX}/auth/forgot-password`, input);
}

export async function confirmPasswordReset(input: ResetPasswordRequest): Promise<TokenPair> {
  const { data } = await apiClient.post<TokenPair>(
    `${API_VERSION_PREFIX}/auth/reset-password`,
    input,
  );
  return data;
}
